/**
 * Knowledge Base articles that offer a "Go to …" CTA into the live UI.
 * `path` may include a `helpGuide` query consumed by the target page.
 */
export type KnowledgeBaseTryIt = {
  path: string;
  /** i18n key under the help namespace (e.g. knowledgeBase.goToAddUser). */
  labelKey: string;
};

export const HELP_GUIDE_ADD_USER = "add-user";
export const HELP_GUIDE_CUSTOMIZE = "customize";
export const HELP_GUIDE_DOWNLOAD_REPORT = "download-report";
export const HELP_GUIDE_MANAGE_ORG = "manage-organization";
export const HELP_GUIDE_ORG_LOGO = "organization-logo";
export const HELP_GUIDE_KPI_LIMITS = "kpi-limits";
export const HELP_GUIDE_USERS_OVERVIEW = "users-overview";
export const HELP_GUIDE_CHANGE_LANGUAGE = "change-language";
export const HELP_GUIDE_APPEARANCE = "appearance-theme";
export const HELP_GUIDE_BRANCH_ANALYSIS = "branch-analysis-overview";
export const HELP_GUIDE_COMPARE_BRANCHES = "compare-branches";

export const KNOWLEDGE_BASE_TRY_IT: Record<string, KnowledgeBaseTryIt> = {
  "add-user": {
    path: `/users?helpGuide=${HELP_GUIDE_ADD_USER}`,
    labelKey: "knowledgeBase.goToAddUser",
  },
  "customize-dashboard": {
    path: `/?helpGuide=${HELP_GUIDE_CUSTOMIZE}`,
    labelKey: "knowledgeBase.goToCustomizeDashboard",
  },
  "kpi-limits": {
    path: `/?helpGuide=${HELP_GUIDE_KPI_LIMITS}`,
    labelKey: "knowledgeBase.goToKpiLimits",
  },
  "download-report": {
    path: `/report?helpGuide=${HELP_GUIDE_DOWNLOAD_REPORT}`,
    labelKey: "knowledgeBase.goToDownloadReport",
  },
  "branch-analysis-overview": {
    path: `/branch-analysis?helpGuide=${HELP_GUIDE_BRANCH_ANALYSIS}`,
    labelKey: "knowledgeBase.goToBranchAnalysis",
  },
  "compare-branches": {
    path: `/branch-analysis?helpGuide=${HELP_GUIDE_COMPARE_BRANCHES}`,
    labelKey: "knowledgeBase.goToCompareBranches",
  },
  "manage-organization": {
    path: `/organizations?helpGuide=${HELP_GUIDE_MANAGE_ORG}`,
    labelKey: "knowledgeBase.goToEditOrganization",
  },
  "organization-logo": {
    path: `/organizations?helpGuide=${HELP_GUIDE_ORG_LOGO}`,
    labelKey: "knowledgeBase.goToOrganizationLogo",
  },
  approvals: {
    path: "/approvals",
    labelKey: "knowledgeBase.goToApprovals",
  },
  "users-overview": {
    path: `/users?helpGuide=${HELP_GUIDE_USERS_OVERVIEW}`,
    labelKey: "knowledgeBase.goToUsers",
  },
  "change-language": {
    path: `/?helpGuide=${HELP_GUIDE_CHANGE_LANGUAGE}`,
    labelKey: "knowledgeBase.goToChangeLanguage",
  },
  "appearance-theme": {
    path: `/?helpGuide=${HELP_GUIDE_APPEARANCE}`,
    labelKey: "knowledgeBase.goToAppearance",
  },
};
